import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ManagedUserProfileForm } from '../../../core/forms/managed-user.form';
import { PhoneAsYouTypeDirective } from '../../../shared/directives/phone-as-you-type/phone-as-you-type.directive';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-managed-user-profile',
  imports: [SharedModule, PhoneAsYouTypeDirective],
  templateUrl: './managed-user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./managed-user-profile.component.scss'],
})
export class ManagedUserProfileComponent {
  @Input() profileForm: ManagedUserProfileForm;
}
